import { createOptrixisAuthClient } from "@optrixis/auth/client";

export const controlAuthClient = createOptrixisAuthClient({
  twoFactorPage: "/two-factor",
});
